import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsTicker() {
  const items = newsList.slice(0, 6);
  const loop = [...items, ...items];

  if (items.length === 0) return null;

  return (
    <div className="w-full bg-primary-950 border-b border-white/10 overflow-hidden">
      <div className="flex items-center">
        <span className="shrink-0 inline-flex items-center gap-2 bg-accent-500 px-3 md:px-4 py-3 text-xs md:text-sm font-semibold text-background-50 z-10">
          <i className="ri-flashlight-fill" aria-hidden="true"></i>
          最新动态
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee">
            {loop.map((n, index) => (
              <Link
                key={`${n.id}-${index}`}
                to={`/news/${n.id}`}
                className="inline-flex items-center gap-2 px-6 py-3 text-xs md:text-sm text-background-200 hover:text-background-50 transition-colors whitespace-nowrap"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0"></span>
                {n.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}